import {
  Datagrid,
  DeleteButton,
  EditButton,
  List,
  ShowButton,
  TextField,
  useTranslate,
} from "react-admin";

import { RuleDeemedSupplier } from "../../types/ruleDeemedSupplier";
import ListActions from "./ListActions";
import ListFilters from "./ListFilters";

const RulesDeemedSupplierList = () => {
  const translate = useTranslate();

  return (
    <List
      actions={<ListActions />}
      filters={<ListFilters />}
      sort={{ field: "id", order: "DESC" }}
      title={translate("rulesDeemedSupplier.list.title")}
      sx={{
        mt: 1,
        "& .RaList-actions": {
          mb: 1,
        },
      }}
    >
      <Datagrid bulkActionButtons={false} rowClick="show">
        <TextField<RuleDeemedSupplier> source="name" />
        <TextField<RuleDeemedSupplier> source="threshold" />
        <TextField<RuleDeemedSupplier> source="taxIdentifier24s" />
        <TextField<RuleDeemedSupplier> source="taxIdentifierName" />
        <TextField<RuleDeemedSupplier> source="countriesFrom" />
        <TextField<RuleDeemedSupplier> source="countriesTo" />
        <TextField<RuleDeemedSupplier> source="exceptCountriesFrom" />
        <TextField<RuleDeemedSupplier> source="currency" />
        <TextField<RuleDeemedSupplier> source="sapAccount1" />
        <TextField<RuleDeemedSupplier> source="sapAccount2" />
        <ShowButton />
        <EditButton />
        <DeleteButton mutationMode="pessimistic" />
      </Datagrid>
    </List>
  );
};

export default RulesDeemedSupplierList;
